import { useOutletContext } from 'react-router-dom';
import ClientsTable from '../../components/ClientsTable';
import ErrorPage from '../../components/ErrorPage';
import DefaultLayoutV3 from '../../layout/DefaultLayoutV3';
import { workspaceService } from '../../reducers/workspaces/workspaceSlice';
import { useTypedSelector } from '../../stateStore';
import { WorkspaceOutletContext } from '../../types/workspaceTypes';
import { workspaceTypeIsAgent } from '../../utils/helpers/common';

const Clients = () => {
  const { workspaceId } = useOutletContext<WorkspaceOutletContext>();

  const workspace = useTypedSelector(workspaceService.selectors.workspace);

  if (workspace && !workspaceTypeIsAgent(workspace))
    return <ErrorPage notAuthorized />;

  return (
    <DefaultLayoutV3.Content>
      <div className="flex w-full flex-col gap-5">
        <h2>All Clients</h2>
        <ClientsTable workspaceId={workspaceId} />
      </div>
    </DefaultLayoutV3.Content>
  );
};

export default Clients;
